import { render } from "./CheekPage.vue?vue&type=template&id=97917376&scoped=true"
import script from "./CheekPage.vue?vue&type=script&lang=js"
export * from "./CheekPage.vue?vue&type=script&lang=js"

import "./CheekPage.vue?vue&type=style&index=0&id=97917376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97917376"]])

export default __exports__